import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles<Theme>((theme) => ({
    divider: {
        divider: {
            marginTop: '8px'
        },
    },
    inputText: {
        marginTop: '8px'
    }
}))